import { DateRangeObject, FilterValues, IssueChart, isDateRangeObject } from 'shared/types/analytics';
import { IssueChartFilterKind } from './issueChartFilterKind';
import { ISSUE_CHART_FILTER_KINDS } from './issueChartFilterKinds';

/** The values of an issue chart's filters, by kind instead of position. */
export interface IssueChartFilterValues {
  dateRange: DateRangeObject;
  /** Ids chosen in each filter: empty when none is chosen or the chart has no such filter. */
  selectedIds: Record<IssueChartFilterKind, string[]>;
}

/** The ids chosen in a multiselect filter; none for any other value. */
export function toSelectedIds(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((id): id is string => typeof id === 'string') : [];
}

function createEmptySelection(): Record<IssueChartFilterKind, string[]> {
  return {
    [IssueChartFilterKind.originators]: [],
    [IssueChartFilterKind.process]: [],
    [IssueChartFilterKind.sites]: [],
    [IssueChartFilterKind.workType]: [],
    [IssueChartFilterKind.impact]: [],
    [IssueChartFilterKind.assignee]: [],
  };
}

/**
 * Reads the filters an issue chart sent: the date range first, then one value
 * per kind of `ISSUE_CHART_FILTER_KINDS`, in that order.
 */
export function readIssueChartFilterValues(chart: IssueChart, filters: FilterValues): IssueChartFilterValues {
  const [dateRangeFilter, ...kindFilters] = filters.dataScope.filters;
  if (!isDateRangeObject(dateRangeFilter?.value)) {
    throw new Error(`The filters of the ${chart} chart start without a date range.`);
  }

  const selectedIds = createEmptySelection();
  ISSUE_CHART_FILTER_KINDS[chart].forEach((kind, position) => {
    selectedIds[kind] = toSelectedIds(kindFilters[position]?.value);
  });

  return { dateRange: dateRangeFilter.value, selectedIds };
}
